var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJusticeHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline:legal-justice-hammer-hammer-work-legal-mallet-office-company-gavel-justice-judge-arbitration-court",
    clipPath: "url(#clip0_311_13911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.859375 22.7828H13.7165M12.0022 22.7828V21.6971C12.0022 20.577 12.0022 20.0169 11.7842 19.5891C11.5925 19.2128 11.2865 18.9068 10.9102 18.7151C10.4824 18.4971 9.92234 18.4971 8.80223 18.4971H5.77366C4.65356 18.4971 4.0935 18.4971 3.66568 18.7151C3.28936 18.9068 2.98339 19.2128 2.79165 19.5891C2.57366 20.0169 2.57366 20.577 2.57366 21.6971V22.7828",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3501 1.71822L7.20437 7.86399C6.5349 8.53346 6.5349 9.61888 7.20437 10.2884L9.91966 13.0036C10.5891 13.6731 11.6746 13.6731 12.344 13.0036L18.4898 6.85788C19.1593 6.18841 19.1593 5.10298 18.4898 4.43351L15.7745 1.71822C15.105 1.04875 14.0196 1.04875 13.3501 1.71822Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4297 9.92578L23.144 17.6401",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_13911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJusticeHammer);
export default __webpack_public_path__ + "static/media/justice-hammer.09a0da6744c978069a04a79327951452.svg";
export { ForwardRef as ReactComponent };